import React from 'react';
import CameraComponent from './CameraComponentV2';
// import RegisterComponent from './RegisterComponent';
import WellcomeComponent from './WellcomeComponent';

import config from './config';
const webVersion = config.version;
 
function App() {
  return (
    <div style={{maxWidth:'1000px',margin:'0 auto'}}>
    <div style={{fontSize: '10px'}}>v {webVersion}</div>
      <WellcomeComponent />
      {/*
        <CameraComponent />
      */}
    </div>
  );
}
 
export default App;